import React, { useRef } from "react";
import { isValid, startOfMinute } from "date-fns";
import { Calendar as PRCalendar } from "primereact/calendar";
import {
  ShiftAdjustBodyText,
  ShiftAdjustTimeEditingContainer,
  ShiftAdjustDatePicker,
  TimePickerWithKeyboardInputContainer,
} from "./styledComponents";
import { TimePickerWithKeyboardInput } from "./TimePickerWithKeyboardInput";

export type ShiftAdjustTimePickerProps = {
  label: string;
  setDate: (d: Date) => void;
  date?: Date;
  formattedTimezone?: string;
  showKeyboardInput?: boolean;
  onOverlayShow?: (overlay: HTMLElement) => void;
  onOverlayHide?: (overlay: HTMLElement) => void;
};

export const ShiftAdjustTimePicker = ({
  label,
  date,
  setDate,
  formattedTimezone,
  showKeyboardInput = false,
  onOverlayShow,
  onOverlayHide,
}: ShiftAdjustTimePickerProps) => {
  const calendarRef = useRef<PRCalendar>(null);
  return (
    <ShiftAdjustTimeEditingContainer>
      <ShiftAdjustBodyText>
        {label} {formattedTimezone}
      </ShiftAdjustBodyText>
      <ShiftAdjustDatePicker
        calendarRef={calendarRef}
        value={date}
        onChange={(d) => isValid(d.value) && setDate(startOfMinute(d.value as Date))}
        showTime
        showOnFocus={false}
        readOnlyInput
        onShow={() => onOverlayShow && calendarRef.current && onOverlayShow(calendarRef.current.getOverlay())}
        onHide={() => onOverlayHide && calendarRef.current && onOverlayHide(calendarRef.current.getOverlay())}
      />
      {showKeyboardInput && (
        <TimePickerWithKeyboardInputContainer>
          <TimePickerWithKeyboardInput date={date} setDate={setDate} />
        </TimePickerWithKeyboardInputContainer>
      )}
    </ShiftAdjustTimeEditingContainer>
  );
};
